import { createToken, deleteToken, getTokens } from '@entities/token/api'
import { getErrorMessage } from '@shared/lib/errors'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import type { Token } from '../types'

export const useTokens = () => {
    const queryClient = useQueryClient()

    const queryKey = ['tokens']

    const tokens = useQuery({ queryKey, queryFn: getTokens })

    const { message } = App.useApp()

    const createTokenMutation = useMutation({
        mutationFn: createToken,
        onSuccess: (data) => {
            const previousTokens: Token[] = queryClient.getQueryData(queryKey) ?? []
            const updatedChannels = [...previousTokens, data]
            queryClient.setQueryData(queryKey, updatedChannels)
        },
        onError: (error) => message.error(getErrorMessage(error))
    })

    const deleteTokenMutation = useMutation({
        mutationFn: deleteToken,
        onSuccess: (data, variables) => {
            const previousTokens: Token[] = queryClient.getQueryData(queryKey) ?? []
            const updatedTokens = previousTokens.filter((item) => item.id !== variables.id)
            queryClient.setQueryData(queryKey, updatedTokens)
        }
    })

    return {
        tokens: tokens.data,
        isTokensLoading: tokens.isPending,
        createTokenIsLoading: createTokenMutation.isPending,
        deleteTokenIsLoading: deleteTokenMutation.isPending,
        actions: {
            createToken: createTokenMutation.mutateAsync,
            deleteToken: deleteTokenMutation.mutateAsync
        }
    }
}
